import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PageContainer } from "core/components/PageContainer";

export function ArticlePageLoadingSkeleton() {
  return (
    <PageContainer maxWidth="md">
      {/* Breadcrumbs skeleton */}
      <Stack direction="row" spacing={1} mb={2}>
        <Skeleton variant="text" width={60} height={20} />
        <Typography>{">"}</Typography>
        <Skeleton variant="text" width={80} height={20} />
        <Typography>{">"}</Typography>
        <Skeleton variant="text" width={100} height={20} />
      </Stack>

      {/* Title and subtitle skeleton */}
      <Stack mb={3}>
        <Skeleton variant="text" width="70%" height={60} />
        <Skeleton variant="text" width="40%" height={24} />
      </Stack>

      {/* Image skeleton */}
      <Box position="relative" mb={2}>
        <Skeleton variant="rectangular" width="100%" height={300} />
      </Box>

      {/* Description skeleton */}
      <Skeleton variant="text" width="90%" height={20} sx={{ mt: 2 }} />

      {/* Divider */}
      <Divider sx={{ my: 4 }} />

      {/* Content skeleton */}
      <Stack spacing={1} mb={4}>
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="95%" height={20} />
        <Skeleton variant="text" width="88%" height={20} />
        <Skeleton variant="text" width="92%" height={20} />
        <Skeleton variant="text" width="75%" height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="85%" height={20} />
      </Stack>

      {/* CTA Button skeleton */}
      <Stack my={4} direction="row" justifyContent="center">
        <Skeleton variant="rectangular" width={120} height={36} />
      </Stack>

      {/* Divider */}
      <Divider sx={{ my: 4 }} />

      {/* Tags skeleton */}
      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-evenly"
        alignItems="flex-start"
      >
        <Stack spacing={1} justifyContent="center">
          <Skeleton
            variant="text"
            width={40}
            height={24}
            sx={{ alignSelf: "center" }}
          />
          <Stack spacing={1} justifyContent="center" direction="row">
            <Skeleton variant="rectangular" width={60} height={24} />
            <Skeleton variant="rectangular" width={80} height={24} />
            <Skeleton variant="rectangular" width={50} height={24} />
          </Stack>
        </Stack>
      </Stack>
    </PageContainer>
  );
}
